<template>
  <div class="profile-dropdown">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" :aria-label="$t('Открыть меню профиля')">
          <div class="user-letter">
            {{ letter }}
            <span class="caret" aria-hidden="true"></span>
          </div>
        </v-btn>
      </template>
      <v-list class="profile-dropdown-content">
        <v-list-item>
          <router-link :to="$i18nRoute({ name: 'profile' })">{{ $t('Личный кабинет') }}</router-link>
        </v-list-item>
        <v-list-item v-if="isEnforecement">
          <a href="#" @click.prevent="sendEnforcement()">{{ $t('Исполнение законов') }}</a>
        </v-list-item>
        <v-list-item >
          <a href="#" @click.prevent="logout">{{ $t('Выйти') }}</a>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import {Trans} from '../../plugins/Translation'

export default {
  data: () => ({
    letter: ''
  }),
  computed: {
    user() {
      return this.$store.state.getUser.currentUser
    },

    //Убрать потом условие админа
    isEnforecement() {
      if (!this.user) {
        return false
      }

      return this.user.roleAdmin === true
    },
  },
  async created() {
    await this.$store.dispatch('fetchCurrentUser')
    if (this.user) {
      this.letter = this.user.second_name.charAt(0)
    }
  },
  methods: {
    sendEnforcement () {
      this.$router.push({
        name: 'enforcement-law',
      })
    },
    async logout() {
      await this.$store.dispatch('logout')
      await this.$router.push(Trans.currentLocaleUrl + '/login')
    }
  }
}
</script>

<style scoped>

</style>
